module.exports = __webpack_public_path__ + "static/media/logo.f7b07f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 196
// module chunks = 0